module.exports = __webpack_public_path__ + "media/entities/default-7b349606.png";